export default __webpack_public_path__ + "static/media/30.afeed4a3.jpg";